import { useState, useEffect, useCallback } from 'react';
import { useAuth } from '../contexts/AuthContext';

export function useFavorites() {
  const { user } = useAuth();
  const [favoriteSlug, setFavoriteSlugs] = useState<Set<string>>(new Set());
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!user) { setFavoriteSlugs(new Set()); return; }
    setLoading(true);
    fetch('/api/favorites')
      .then(r => r.json())
      .then((games: { slug: string }[]) => {
        setFavoriteSlugs(new Set(games.map(g => g.slug)));
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [user]);

  const toggleFavorite = useCallback(async (slug: string): Promise<boolean | null> => {
    if (!user) return null; // null = not logged in
    try {
      const res = await fetch(`/api/favorites/${slug}`, { method: 'POST' });
      const data = await res.json();
      setFavoriteSlugs(prev => {
        const next = new Set(prev);
        if (data.favorited) next.add(slug);
        else next.delete(slug);
        return next;
      });
      return data.favorited;
    } catch {
      return null;
    }
  }, [user]);

  const isFavorite = useCallback((slug: string) => favoriteSlug.has(slug), [favoriteSlug]);

  return { isFavorite, toggleFavorite, loading };
}
